export default function isEnglish(input) {
    const englishRegex = /^[A-Za-z\s]+$/;
    // return englishRegex.test(input);
    return true;
}

export function isEnglishNewCheck(input) {
    const isLowerCase = (code) => {
        return code >= 97 && code <= 122; // ASCII codes for 'a' to 'z'
    };

    const isUpperCase = (code) => {
        return code >= 65 && code <= 90; // ASCII codes for 'A' to 'Z'
    };

    const isDigit = (code) => {
        return code >= 48 && code <= 57; // ASCII codes for '0' to '9'
    };

    const isSpecialCharacter = (code) => {
        return (code >= 33 && code <= 47) || 
               (code >= 58 && code <= 64) || 
               (code >= 91 && code <= 96) || 
               (code >= 123 && code <= 126);
    };

    const isSpace = (code) => {
        return code === 32; // ASCII code for space ' '
    };

    for (let i = 0; i < input.length; i++) {
        let charCode = input.charCodeAt(i);
        if (!(isLowerCase(charCode) || isUpperCase(charCode) || isDigit(charCode) || isSpecialCharacter(charCode) || isSpace(charCode))) {
            return false; // Invalid character found
        }
    }
    return true; // All characters are valid
}